import type { PromptTemplate, PromptTemplateCreateRequest } from '~/api/generated';

export const usePromptTemplateStore = defineStore('promptTemplate', {
  state: () => ({
    promptTemplates: [] as PromptTemplate[]
  }),
  getters: {
    getPromptTemplateById:
      (state) =>
      (id: PromptTemplate['id']): PromptTemplate | null =>
        state.promptTemplates.find((template) => template.id === id) || null
  },
  actions: {
    async getPromptTemplates() {
      const apiStore = useApiStore();

      const promptTemplates = await apiStore.api.promptTemplates.promptTemplateList();

      if (promptTemplates) {
        this.promptTemplates = promptTemplates;
      }
    },

    createPromptTemplate({ requestBody }: { requestBody: PromptTemplateCreateRequest }) {
      const apiStore = useApiStore();

      return apiStore.api.promptTemplates.promptTemplateCreate({ requestBody });
    },

    updatePromptTemplate({
      promptTemplateId,
      requestBody
    }: {
      promptTemplateId: PromptTemplate['id'];
      requestBody: PromptTemplateCreateRequest;
    }) {
      const apiStore = useApiStore();

      return apiStore.api.promptTemplates.promptTemplateUpdate({ promptTemplateId, requestBody });
    },

    deletePromptTemplate({ promptTemplateId }: { promptTemplateId: PromptTemplate['id'] }) {
      const apiStore = useApiStore();

      return apiStore.api.promptTemplates.promptTemplateDelete({ promptTemplateId });
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
});
